/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * @example
 *     {
 *         body: "string"
 *     }
 */
export interface DidCommMessageRecvRequest {
    body: string;
}
